module.exports = __webpack_public_path__ + "assets/media/1.2d0044dd.wav";